import { createRecipe } from './runtime';

const inputConfig = {"name":"input","defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm"]}}

export const input = /* @__PURE__ */ createRecipe(inputConfig)